var EHDI = EHDI || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.PauseButton = function() {
    EHDI.displays.Button.call(this, EHDI.Assets.images["btn_pause"], EHDI.Assets.images["btn_pause2"], null, null);

    this.isPaused = false;
    this.isEndGame = false;
    
    // APP.managers.sound.autoResumeToggle(false);
    
    this.setOnClickFunction(this.sfxThenPause.bind(this));
    
    this.position.set(APP.config.stageWidth * 0.95, APP.config.stageHeight * 0.075);
    
    APP.game.btnPause = this;

    this.pauseTheGame = APP.game.btnPause.pauseGame.bind(APP.game.btnPause).bind(APP.game.btnPause);
    this.checkIfInterrupt = APP.game.btnPause.checkInterrupt.bind(APP.game.btnPause);
    
    window.addEventListener("blur", this.pauseTheGame);
    window.addEventListener("pagehide", this.pauseTheGame);
    window.addEventListener("webkitvisibilitychange", this.checkIfInterrupt);
    window.addEventListener("visibilitychange", this.checkIfInterrupt);
    
};

EHDI.components.PauseButton.prototype = Object.create(EHDI.displays.Button.prototype);

EHDI.components.PauseButton.prototype.sfxThenPause = function() {
    APP.managers.sound.playSFX("button_sfx");
    this.pauseGame();
}

EHDI.components.PauseButton.prototype.checkInterrupt = function() {
    if (window.document.webkitHidden || window.document.hidden) {
			this.pauseGame();
    }
};

EHDI.components.PauseButton.prototype.pauseGame = function() {
    if(this.isPaused || this.isEndGame)
        return;
    this.isPaused = true;
    APP.managers.scene.pushPopUp(new APP.popups.PausePopup( true ), { y : new EHDI.scene.TransitionParameter(-APP.config.stageHeight, APP.config.stageHeight * 0.5), duration : 0.25});
}; 

EHDI.components.PauseButton.prototype.resumeGame = function() {
    this.isPaused = false;
};

EHDI.components.PauseButton.prototype.endGame = function() {
    this.isEndGame = true;
//    this.hidePauseButton();
    window.removeEventListener("blur", this.pauseTheGame);
    window.removeEventListener("pagehide", this.pauseTheGame);
    window.removeEventListener("webkitvisibilitychange", this.checkIfInterrupt);
    window.removeEventListener("visibilitychange", this.checkIfInterrupt);
};

EHDI.components.PauseButton.prototype.destroy = function() {
    // APP.managers.sound.autoResumeToggle(true);
	EHDI.aka.Sprite.prototype.destroy.apply(this, arguments);
}

EHDI.components.PauseButton.prototype.hidePauseButton = function() {
    TweenLite.to(this, 0.25, {y : -this.y});
};